<template>
    <div class="award">
        <div v-for="(item, index) in lang" :key="index">
            <div class="textWrap">
                {{ titleMsg }}
                <br />
                {{ item[14] }}
            </div>
            <div class="textWrap textTop">{{ item[15] }}</div>
            <div style="text-align: center">
                <div class="copyWrap">
                    <!-- <input type="text" v-model="copyValue" id="input" style="opacity: 0; height: 20px; width: 1px" /> -->
                    <input type="text" v-model="copyValue" id="input" class="input" />
                    <button class="tag-read" :data-clipboard-text="copyValue" @click="copys">
                        <span><img src="@/assets/image/copy.png" alt="" /></span>
                    </button>
                </div>
            </div>

            <div class="textWrap textTop">{{ item[16] }}</div>
            <div class="urlWrap">
                <div class="url">
                    <a href="https://test-gift.survivorio.com" v-show="isTest">https://test-gift.survivorio.com</a>
                    <a href="https://gift.survivorio.com" v-show="!isTest">https://gift.survivorio.com</a>
                </div>
            </div>
        </div>
        <div class="tooltip" v-show="infoShow">
            <div class="tooltiptext">{{ tooltipMsg }}</div>
        </div>
    </div>
</template>

<script>
import queryString from 'query-string'
import { lang } from '@/tool/lang'
import Clipboard from 'clipboard'

var parsed = queryString.parse(location.search || '') || {}
export default {
    data() {
        return {
            copyValue: '',
            lang: [{}],
            titleMsg: '',
            isTest: false,
            language: '',
            lang2: '',
            infoShow: false,
            tooltipMsg: ''
        }
    },
    watch: {
        infoShow(newValue, oldValue) {
            if (newValue) {
                let timeoutId = setTimeout(
                    function () {
                        this.infoShow = false
                        clearTimeout(timeoutId)
                    }.bind(this),
                    2000
                )
            }
        }
    },
    created() {
        this.copyValue = localStorage.getItem('myGiftCode') || ''
        this.getLanguage()
    },
    mounted() {
        for (var i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
        if (localStorage.getItem('username')) {
            this.titleMsg = this.lang[0][13].replace('{Name}', localStorage.getItem('username'))
        }
        if (location.hostname.indexOf('localhost') >= 0) {
            this.isTest = true
        }

        if (window.location.hostname.indexOf('test') > -1) {
            this.isTest = true
        }

        if (location.hostname.match(/[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+/)) {
            this.isTest = true
        }
    },
    methods: {
        copys() {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                console.log('复制成功')
                this.tooltipMsg = this.lang[0][28] || '礼包码复制成功'
                this.infoShow = true
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        getLanguage() {
            if (
                parsed.language &&
                (parsed.language === 'en' ||
                    parsed.language === 'zh-TW' ||
                    parsed.language === 'zh-CN' ||
                    parsed.language === 'ja' ||
                    parsed.language === 'ko')
            ) {
                this.language = parsed.language
                // this.abc = this.language
                this.lang2 = this.language.substr(0, 2)
                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            } else {
                var type = navigator.appName
                if (type == 'Netscape') {
                    var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
                } else {
                    var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
                }
                var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
                this.lang2 = lang2
                if (lang2 === 'zh') {
                    let zh = lang.substr(0, 5)
                    this.language = zh
                } else if (lang2 == 'ko') {
                    this.language = 'ko'
                } else if (lang2 == 'ja') {
                    this.language = 'ja'
                } else {
                    this.language = 'en'
                }
                if (this.language === 'zh-cn') {
                    this.language = 'zh-CN'
                }
                if (this.language === 'zh-tw') {
                    this.language = 'zh-TW'
                }
                if (['en', 'ja', 'ko', 'zh-CN', 'zh-TW'].indexOf(this.language) < 0) {
                    this.language = 'en'
                }
                // this.abc = this.language

                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            }
        },
        copy() {
            const input = document.getElementById('input')
            input.value = localStorage.getItem('myGiftCode') || ''

            // 聚焦
            input.focus()
            // 选择需要复制的文本
            if (input.setSelectionRange) {
                input.setSelectionRange(0, input.value.length)
            } else {
                input.select()
            }
            input.setAttribute('value', '听说你想复制我')
            try {
                const result = document.execCommand('copy')
                // console.log('成功', input.value)

                this.tooltipMsg = this.lang[0][28] || '礼包码复制成功'
                this.infoShow = true
            } catch (e) {
                console.error('复制失败，请重试~')
            }
            input.blur()
            document.activeElement.blur()
        }
    }
}
</script>


<style scoped lang="less">
.award {
    margin: 0;
    height: 100vh;
    width: 100%;
    background: url('../assets/image/resultspage_bg.png') 100% 100% no-repeat;
    background-size: 100% 100%;
    color: #fff;
    font-size: 2.55rem;
    line-height: 3rem;
    padding-top: 30.125rem;
    .textWrap {
        text-align: center;
        padding: 0 6.25rem;
    }
    .textTop {
        padding-top: 7.5rem;
        padding-bottom: 1.25rem;
    }
    .copyWrap {
        display: inline-block;
        height: 7.5rem;
        text-align: center;
        margin: 0 auto;
        .input {
            display: inline-block;
            margin-top: 1rem;
            width: 40rem;
            height: 100%;
            background: rgba(255, 255, 255, 0.42);
            border-radius: 0.75rem;
            text-align: center;
            font-size: 3rem;
            border: 1px solid #ffffff;
            color: #704b49;
            box-sizing: border-box;
            float: left;
        }
        button {
            height: 100%;
            border: none;
            padding: 0;
            margin: 0;
            float: left;
            border-radius: 0.75rem;
            background: url('../assets/image/copy.png') 100% 100% no-repeat;
            background-size: 100% 100%;
        }
        span {
            img {
                height: 100%;
                // margin-left: -6px;
                // vertical-align: middle;
                // margin-top: -3px;
            }
        }
    }
    .urlWrap {
        width: 100%;
        padding: 0 3.875rem;
        .url {
            background: rgba(255, 255, 255, 0.42);
            border-radius: 0.75rem;
            height: 9.375rem;
            line-height: 9.375rem;
            border: 1px solid #ffffff;
            color: #704b49;
            text-align: center;
            a {
                color: #fff;
                text-decoration: underline;
            }
        }
    }
    .btnWrap {
        text-align: center;
        img {
            margin-top: 4rem;
            width: 33.75rem;
        }
    }
}

.tooltip {
    width: 100%;
    position: fixed;
    left: 0;
    top: 6.25rem;
    text-align: center;
    .tooltiptext {
        max-width: 60%;
        background: rgba(0, 0, 0, 0.3);
        display: inline-block;
        padding: 3.25rem;
        border-radius: 2.625rem;
        color: #ffffff;
        font-size: 2.2rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/award.vue